import { Avatar, Space, Spin, Typography, Upload } from 'antd';

import styled from '@emotion/styled';
import { useS3Upload } from 'lib/s3';
import { CameraOutlined } from '@ant-design/icons';

const { Dragger } = Upload;

export default function DraggerZone({ fileList = [], loading = false, onChange = undefined }) {
  const { forceRequest } = useS3Upload();

  return (
    <DraggerContainer
      multiple
      name="file"
      accept=".jpg, .jpeg"
      showUploadList={false}
      fileList={fileList}
      customRequest={forceRequest}
      onChange={onChange}
    >
      <div className="dragger-box">
        <Spin spinning={loading}>
          <Space direction="vertical" align="center">
            <Avatar icon={<CameraOutlined />} />
            <Typography.Text strong>เพิ่มรูปภาพ</Typography.Text>
            {fileList.length <= 0 && <Typography.Text style={{ fontSize: 12 }}>หรือลากแล้ววาง</Typography.Text>}
          </Space>
        </Spin>
      </div>
    </DraggerContainer>
  );
}

const DraggerContainer = styled(Dragger)({
  border: 'unset !important',
  backgroundColor: 'transparent !important',
  '.ant-upload': {
    padding: '0px !important',
  },
  '.dragger-box': {
    border: '1px solid #000',
    borderRadius: 5,
    backgroundColor: '#202735',
    padding: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  '.ant-avatar': {
    border: '1px solid #000',
    width: 50,
    height: 50,
    background: 'rgba(0, 0, 0, 0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
